import { messageListEventBus } from '~/components/MessageList';

/**
 * Please carefully adjust this START n END chat statement
 * because it needed if it parsed into zendesk tiket inbox as a chat
 * affected parser: store/zopim/ticket.js
 */

export const START_CHAT_STATEMENT = '(Pesan ini otomatis dari sistem untuk membantu komplain)';
export const END_CHAT_STATEMENT = '******';

export const wrapAutoTextChat = chatContent => `${START_CHAT_STATEMENT}\n${chatContent}\n${END_CHAT_STATEMENT}`;

/**
 *
 * @param {string} text
 * @param {object} options = {timestamp = Date, nick = String, display_name = String}
 */
export const sendTextToChat = (text = '', options = {}) => {
  messageListEventBus.$emit('clientTextMessage', { msg: wrapAutoTextChat(text), ...options });
};

/**
 *
 * @param {file} file
 * use correct file convention checkout JS File API https://developer.mozilla.org/en-US/docs/Web/API/File/File
 * known zopim supported file type: image
 */
export const sendFileToChat = file => {
  messageListEventBus.$emit('clientFileMessage', file);
};
